import { render } from "./ComponentePPAventa.vue?vue&type=template&id=7a304c96"
import script from "./ComponentePPAventa.vue?vue&type=script&lang=js"
export * from "./ComponentePPAventa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__